<script setup lang="ts">
defineProps({
    currentPath: {
        type: String,
        default: ''
    }
})

const languageList = [
    { language: 'Français', countryCode: 'fr' },
    { language: 'English', countryCode: 'en' },
    { language: 'Deutsch', countryCode: 'de' },
    { language: 'Español', countryCode: 'es' },
    { language: 'Nederlands', countryCode: 'nl' },
    { language: 'Português', countryCode: 'pt' },
    { language: 'Český', countryCode: 'cs' },
    { language: 'Dansk', countryCode: 'da' },
    { language: 'Eesti', countryCode: 'et' },
    { language: 'Suomalainen', countryCode: 'fi' },
    { language: 'Magyar', countryCode: 'hu' },
    { language: 'Italiano', countryCode: 'it' },
    { language: 'Lietuvos', countryCode: 'lt' },
    { language: 'Latvijas', countryCode: 'lv' },
    { language: 'Norsk', countryCode: 'no' },
    { language: 'Polski', countryCode: 'pl' },
    { language: 'Slovenski', countryCode: 'sv' }
]
</script>

<template>
    <div class="languages-list">
        <div v-for="language of languageList" :key="language.language">
            <a
                :href="`https://${language.countryCode}.chargemap.com${currentPath}`"
                :title="language.language"
            >
                {{ language.language }}
            </a>
        </div>
    </div>
</template>

<style scoped>
.languages-list {
  @apply grid-cols-2 mx-4 grid gap-x-2 w-full h-auto bg-white relative md:mx-auto rounded-3xl;
}
.languages-list div {
  @apply py-3 px-1 border-b-[1px] border-solid border-zinc-200 w-full;
}
.languages-list a {
  @apply block py-1 px-1 text-zinc-800 hover:text-sky-400 text-base w-full transition-all duration-300 ease-in-out;
}
</style>
